import styles from './style.module.scss';
// import { ReactComponent as BlackLogo } from '../../../assets/svg/ingame-logo-black.svg';
// import { ReactComponent as NewLogo } from '../../../assets/svg/ingame-logo-new.svg';
import { ReactComponent as Logo } from '../../../assets/svg/ingame-logo-n.svg';
import { ReactComponent as Contact } from '../../../assets/svg/footer-contact.svg';

import { useState } from 'react';
import { Row, Col, Space } from 'antd';
import { BoxFrame } from '../../common/box-frame';
import getFormatMessage from '../../../locales/get-format-message';
import { getLocaleLanguage, isDark, LanguageType } from '../../../lib';
import { getConfig } from '../../../config';
import { IAppLinkConfig } from '../../../model';
import { jumpLogin } from '../../../lib/jump-website';
import { getLoginToken } from '../../lib';
import classNames from 'classnames';
import footerTop from '../../../assets/svg/footer-top.svg';

export const FooterComponent = () => {
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const copyRight = getConfig()?.copyRight;
  const userURL = getConfig()?.userURL;
  const consoleURL = getConfig()?.consoleURL;
  const { copyRightText, protocolLinks, filingCaseNumber, filingLink } =
    copyRight;
  const documentConfig = getConfig()?.documentConfig;
  const ingameModule = documentConfig.modules.find(
    (module) => module.key === 'INGAME'
  );
  const handleDocumentationClick = () => {
    const pid = ingameModule?.pid[currentStoreLanguage];
    const ticket = getLoginToken();
    if (ticket) {
      if (consoleURL && pid) {
        const url = `${consoleURL}/doc/detail/${pid}`;
        window.open(url, '_blank');
      }
    } else {
      jumpLogin();
    }
  };

  const goToDownload = () => {
    const ticket = getLoginToken();
    if (ticket) {
      if (consoleURL) {
        const url = `${consoleURL}/download/download-center`;
        window.open(url, '_blank');
      }
    } else {
      jumpLogin();
    }
  };

  const [linkId, setLinkId] = useState<number>(1);
  let prevMenuSelectId = 0;
  const updateLinkId = (id: number) => {
    if(linkId === id){
      prevMenuSelectId = 0;
      setLinkId(0);
    }else{
      setLinkId(id);
      prevMenuSelectId = id;
    }
    
  };
  return (
    <>
      <div
        className={classNames(
          styles.footerTopBox,
          isDark() ? styles.darkTop : ''
        )}
        style={{ display: isDark() ? 'block' : 'none' }}
      >
        <img src={footerTop} />
      </div>
      <BoxFrame
        className={classNames(
          styles.footerCommonComponent,
          isDark() ? styles.darkFooterComponent : ''
        )}
      >
        <Row gutter={[48, 48]}>
          <Col flex={1}>
            <Space align="start" size={128} wrap className={styles.footerSpace}>
              <dl
                className={classNames(
                  styles.footerListDarkBox,
                  linkId === 1 ? styles.showLink : ''
                )}
                onClick={() => updateLinkId(1)}
              >
                <dt>{getFormatMessage('download')}</dt>
                <dd>
                  <span onClick={goToDownload}>SDK</span>
                </dd>
                <dd>
                  <span onClick={goToDownload}>Demo</span>
                </dd>
                <dd>
                  <span onClick={goToDownload}>Tools</span>
                </dd>
              </dl>
              <dl
                className={classNames(
                  styles.footerListDarkBox,
                  linkId === 2 ? styles.showLink : ''
                )}
                onClick={() => updateLinkId(2)}
              >
                <dt>{getFormatMessage('resources')}</dt>
                <dd>
                  <span onClick={handleDocumentationClick}>
                    {getFormatMessage('docs')}
                  </span>
                </dd>
                <dd>
                  <a href="/roadmap">RoadMap</a>
                </dd>
              </dl>
              <dl
                className={classNames(
                  styles.footerListDarkBox,
                  linkId === 3 ? styles.showLink : ''
                )}
                onClick={() => updateLinkId(3)}
              >
                <dt>{getFormatMessage('support')}</dt>
                <dd>
                  <a href="/get-started">
                    {getFormatMessage('get_started_uppercase')}
                  </a>
                </dd>
                {/* <dd>
                    <a href="">{getFormatMessage('about')}</a>
                  </dd> */}
              </dl>
            </Space>
          </Col>
          <Col className={`ele-class`}>
            <Space>
              <dl
                className={classNames(
                  styles.footerListDarkBox,
                  styles.footerListDarkBoxExtra
                )}
              >
                <dt>{getFormatMessage('we_are_online')}</dt>
                <dd className={styles.footerListDarkContact}>
                  <Contact className={styles.contactIcon} />
                  <a
                    href={`${userURL}/contact?ingame_language=${currentStoreLanguage}`}
                  >
                    {getFormatMessage('contact_us')}
                  </a>
                </dd>
                <dd className="list-extra-text">
                  <span className="list-disable-click">
                    {getFormatMessage('contact_for_product')}
                  </span>
                </dd>
              </dl>
            </Space>
          </Col>
          <Col span={24}>
            <Row gutter={[24, 24]} align="middle">
              <Col>
                <span className={styles.footerLogo}>
                  {/* {isDark() ? (
                    <NewLogo
                      style={{ width: 84, height: 17, marginTop: '-2px' }}
                    />
                  ) : (
                    <BlackLogo
                      style={{ width: 84, height: 17, marginTop: '-2px' }}
                    />
                  )} */}
                  <Logo style={{ width: 24, height: 24, marginTop: '-2px' }} />
                </span>
              </Col>
              <Col>
                <p className={styles.footerDarkCopyRight}>
                  {copyRightText}
                  <span
                    className={filingLink ? styles.link : ''}
                    onClick={() => window.open(filingLink, '_blank')}
                  >
                    {filingCaseNumber}
                  </span>
                </p>
              </Col>
              <Col flex={1}>
                <p className={styles.footerDarkEndLink}>
                  {protocolLinks[currentStoreLanguage]
                    ? protocolLinks[currentStoreLanguage].map(
                        (link: IAppLinkConfig) => {
                          let processedUrl = '';
                          if (link.url === '') {
                            processedUrl = '';
                          } else if (link.url.includes('.com')) {
                            processedUrl = link.url;
                          } else {
                            processedUrl = `${consoleURL}${link.url}`;
                          }
                          return (
                            <a href={processedUrl} target="_blank">
                              {link.label}
                            </a>
                          );
                        }
                      )
                    : null}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </BoxFrame>
    </>
  );
  // }
  // return (
  //   <BoxFrame className={styles.footerComponent}>
  //     <Row gutter={[48, 48]}>
  //       <Col flex={1}>
  //         <Space align="start" size={128} wrap className={styles.footerSpace}>
  //           <dl className={styles.footerListBox}>
  //             <dt>{getFormatMessage('products')}</dt>
  //             <dd>
  //               <a href="/#multiplayer">{getFormatMessage('multiplayer')}</a>
  //             </dd>
  //             <dd>
  //               <a href="/#social">{getFormatMessage('social')}</a>
  //             </dd>
  //             <dd>
  //               <a href="/#content">{getFormatMessage('content')}</a>
  //             </dd>
  //             <dd>
  //               <a href="/#economy">{getFormatMessage('economy')}</a>
  //             </dd>
  //             {/* <dd>
  //               <a href="/#engage">{getFormatMessage('engage')}</a>
  //             </dd> */}
  //             <dd>
  //               <a href="/#analytics">{getFormatMessage('analytics')}</a>
  //             </dd>
  //           </dl>
  //           <dl className={styles.footerListBox}>
  //             <dt>{getFormatMessage('resources')}</dt>
  //             {/* <dd>
  //               <a href="">{getFormatMessage('roadmap')}</a>
  //             </dd> */}
  //             <dd>
  //               <span onClick={handleDocumentationClick}>
  //                 {getFormatMessage('docs')}
  //               </span>
  //             </dd>
  //           </dl>
  //           <dl className={styles.footerListBox}>
  //             <dt>{getFormatMessage('support')}</dt>
  //             <dd>
  //               <a href="/get-started">
  //                 {getFormatMessage('get_started_uppercase')}
  //               </a>
  //             </dd>
  //             {/* <dd>
  //               <a href="">{getFormatMessage('about')}</a>
  //             </dd> */}
  //           </dl>
  //         </Space>
  //       </Col>
  //       <Col>
  //         <Space>
  //           <dl className={styles.footerListBox}>
  //             <dt>{getFormatMessage('we_are_online')}</dt>
  //             <dd>
  //               <a
  //                 href={`${userURL}/contact?ingame_language=${currentStoreLanguage}`}
  //               >
  //                 {getFormatMessage('contact_us')}
  //               </a>
  //             </dd>
  //             <dd className="list-extra-text">
  //               <span className="list-disable-click">
  //                 {getFormatMessage('contact_for_product')}
  //               </span>
  //             </dd>
  //           </dl>
  //         </Space>
  //       </Col>
  //       <Col span={24}>
  //         <Row gutter={[24, 24]} align="middle">
  //           <Col>
  //             <span className={styles.footerLogo}>
  //               <Logo width={80} height={23} />
  //             </span>
  //           </Col>
  //           <Col>
  //             <p className={styles.footerCopyRight}>
  //               {copyRightText}
  //               <span
  //                 className={filingLink ? styles.link : ''}
  //                 onClick={() => window.open(filingLink, '_blank')}
  //               >
  //                 {filingCaseNumber}
  //               </span>
  //             </p>
  //           </Col>
  //           <Col flex={1}>
  //             <p className={styles.footerEndLink}>
  //               {protocolLinks[currentStoreLanguage]
  //                 ? protocolLinks[currentStoreLanguage].map(
  //                     (link: IAppLinkConfig) => {
  //                       let processedUrl = '';
  //                       if (link.url === '') {
  //                         processedUrl = '';
  //                       } else if (link.url.includes('.com')) {
  //                         processedUrl = link.url;
  //                       } else {
  //                         processedUrl = `${consoleURL}${link.url}`;
  //                       }
  //                       return (
  //                         <a href={processedUrl} target="_blank">
  //                           {link.label}
  //                         </a>
  //                       );
  //                     }
  //                   )
  //                 : null}
  //             </p>
  //           </Col>
  //         </Row>
  //       </Col>
  //     </Row>
  //   </BoxFrame>
  // );
};
